import React, { useState, useEffect } from "react"
import { linkedStudentsApi } from "../../lib/api"
import { useToast } from "../../contexts/ToastContext"

const LinkedStudentsList = () => {
  const [students, setStudents] = useState([])
  const [loading, setLoading] = useState(true)
  const toast = useToast()

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      setLoading(true)
      const data = await linkedStudentsApi.list()
      setStudents(data.students || [])
    } catch (err) {
      console.error("Failed to fetch linked students:", err)
    } finally {
      setLoading(false)
    }
  }

  const handleUnlink = async (studentId, studentName) => {
    if (!confirm(`Are you sure you want to unlink ${studentName}? You will no longer be able to view their assignments.`)) {
      return
    }

    try {
      await linkedStudentsApi.unlink(studentId)
      toast.success("Student unlinked successfully")
      fetchStudents()
    } catch (err) {
      toast.error(err.message || "Failed to unlink student")
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  if (loading) {
    return (
      <div className="animate-pulse space-y-3">
        <div className="h-16 bg-gray-200 rounded-lg"></div>
      </div>
    )
  }

  if (students.length === 0) {
    return (
      <p className="text-gray-500 text-sm text-center py-4">
        No students linked to your account yet. Ask a student to send you an invitation.
      </p>
    )
  }

  return (
    <div className="space-y-3">
      {students.map((student) => (
        <div
          key={student.id}
          className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-white font-medium">
              {student.name?.charAt(0)?.toUpperCase() || student.email?.charAt(0)?.toUpperCase()}
            </div>
            <div className="min-w-0">
              <p className="font-medium text-gray-900 truncate">{student.name || "Student"}</p>
              <p className="text-sm text-gray-500 truncate">{student.email}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-xs text-gray-400">
              Linked {formatDate(student.linked_at)}
            </span>
            <button
              onClick={() => handleUnlink(student.id, student.name || student.email)}
              className="text-sm text-red-600 hover:text-red-800"
            >
              Unlink
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default LinkedStudentsList
